module.exports = __webpack_public_path__ + "static/media/logo-ttdk.565e6159.png";